























import { Vue, Component, Prop } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as images from "../../assets/images";
import { DocConvenzione } from "../../_models/docConvenzione";
import { bus } from "../../main";

//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component
export default class ConvenzioneTirEstivoReview extends Vue {
  @Prop() docInfo!: DocConvenzione;
  private ruoloUtente: number[];
  private tipoAttivita: string;

  private elements: DocConvenzione;

  private doc: any;

  constructor() {
    super();
    this.ruoloUtente = [];
    this.tipoAttivita = "";
    this.elements = {
      idConvenzione: this.docInfo.idConvenzione,
      denominazioneIstituto: this.docInfo.denominazioneIstituto,
      indirizzoIstituto: this.docInfo.indirizzoIstituto,
      capIstituto: this.docInfo.capIstituto,
      comuneIstituto: this.docInfo.comuneIstituto,
      provinciaIstituto: this.docInfo.provinciaIstituto,
      telefonoIstituto: this.docInfo.telefonoIstituto,
      emailIstituto: this.docInfo.emailIstituto,
      codiceFiscaleIstituto: this.docInfo.codiceFiscaleIstituto,
      dirigenteIstituto: this.docInfo.dirigenteIstituto,
      luogoNascitaDirigenteIstituto: this.docInfo.luogoNascitaDirigenteIstituto,
      dataNascitaDirigenteIstituto: this.docInfo.dataNascitaDirigenteIstituto,
      denominazioneAzienda: this.docInfo.denominazioneAzienda,
      indirizzoAzienda: this.docInfo.indirizzoAzienda,
      capAzienda: this.docInfo.capAzienda,
      comuneAzienda: this.docInfo.comuneAzienda,
      provinciaAzienda: this.docInfo.provinciaAzienda,
      telefonoAzienda: this.docInfo.telefonoAzienda,
      emailAzienda: this.docInfo.emailAzienda,
      pecAzienda: this.docInfo.pecAzienda,
      pIvaAzienda: this.docInfo.pIvaAzienda,
      rappresentanteAzienda: this.docInfo.rappresentanteAzienda,
      luogoNascitaRappresentanteAzienda: this.docInfo
        .luogoNascitaRappresentanteAzienda,
      dataNascitaRappresentante: this.docInfo.dataNascitaRappresentante,
      dataDocumento: this.docInfo.dataDocumento,
      idStatoDoc: this.docInfo.idStatoDoc,
      firmaAzienda: this.docInfo.firmaAzienda,
      firmaIstituto: this.docInfo.firmaIstituto,
      tipoAttivita: this.docInfo.tipoAttivita,
      numeroProtocollo: this.docInfo.numeroProtocollo,
      idTemplate: this.docInfo.idTemplate,
      codAteco: this.docInfo.codAteco,
      codIstat: this.docInfo.codIstat,
      indirizzoTirocinio: this.docInfo.indirizzoTirocinio,
      comuneTirocinio: this.docInfo.comuneTirocinio,
      provinciaTirocinio: this.docInfo.provinciaTirocinio,
      tutorAziendale: this.docInfo.tutorAziendale,
      tutorFormativo: this.docInfo.tutorFormativo
    };
    this.doc = null;
  }

  createDoc() {
    if (this.elements.firmaAzienda === null) {
      this.elements.firmaAzienda = images.noFirma;
    }

    // var dd = {
    //   /**--------------------------------------------------------
    //      * Le immagini di header e footer sono convertite in Base64
    //      * ed importate dal file Header_Footer.js
    //      ----------------------------------------------------------*/
    //   pageSize: "A4",
    //   // ****** FOOTER *********//
    //   footer: function(/*currentPage, pageCount*/) {
    //     return [
    //       {
    //         image: images.authFooter,
    //         width: "560",
    //         height: "80",
    //         margin: [20, 0]
    //       }
    //     ];
    //   },
    //   // ******** HEADER ******** //
    //   header: function(/*currentPage, pageCount, pageSize*/) {
    //     // you can apply any logic and return any valid pdfmake element

    //     return [
    //       {
    //         // image: images.authHeader,
    //         image: images.authHeader,
    //         width: "525",
    //         height: "90",
    //         margin: [35, 0]
    //       }
    //     ];
    //   },

    //   //******** TESTO DEL DOCUMENTO  ********/
    //   content: [
    //     {
    //       text:
    //         "Convenzione stipulata in data " +
    //         this.elements.dataDocumento +
    //         " con protocolo n. " + this.elements.numeroProtocollo,
    //       style: "bodyText",
    //       margin: [0, 70, 0, 35]
    //     },
    //     {
    //       text: "CONVENZIONE",
    //       alignment: "center",
    //       bold: true,
    //       fontSize: 16
    //     },
    //     {
    //       text: "PER L’ATTIVAZIONE DI TIROCINI ESTIVI DI ORIENTAMENTO",
    //       alignment: "center",
    //       bold: true,
    //       fontSize: 16
    //     },
    //     {
    //       text: "Ai sensi della DGR 19-4575 DEL 16/01/2017",
    //       alignment: "center",
    //       bold: true,
    //       fontSize: 16,
    //       margin: [0, 0, 0, 20]
    //     },
    //     {
    //       text: "TRA",
    //       alignment: "center",
    //       bold: true,
    //       fontSize: 13
    //     },
    //     {
    //       text: "Soggetto Promotore",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 0, 0, 10]
    //     },
    //     {
    //       table: {
    //         widths: [200, "*"],
    //         body: [
    //           [
    //             { text: "Denominazione Istituto", style: "tableTitle" },
    //             {
    //               text: this.elements.denominazioneIstituto,
    //               style: "tableText"
    //             }
    //           ],
    //           [
    //             { text: "Indirizzo", style: "tableTitle" },
    //             { text: this.elements.indirizzoIstituto, style: "tableText" }
    //           ],
    //           [
    //             { text: "CAP Comune Provincia", style: "tableTitle" },
    //             {
    //               text:
    //                 this.elements.comuneIstituto +
    //                 " " +
    //                 this.elements.provinciaIstituto +
    //                 " " +
    //                 this.elements.capIstituto,
    //               style: "tableText"
    //             }
    //           ],
    //           [
    //             { text: "Telefono", style: "tableTitle" },
    //             { text: this.elements.telefonoIstituto, style: "tableText" }
    //           ],
    //           [
    //             { text: "Indirizzo e-mail", style: "tableTitle" },
    //             { text: "pcto@vallauri.edu", style: "tableText" }
    //           ],
    //           [
    //             { text: "PEC", style: "tableTitle" },
    //             { text: "CNISO1700C@PEC.ISTRUZIONE.IT", style: "tableText" }
    //           ],
    //           [
    //             { text: "Codice Fiscale/Partita IVA", style: "tableTitle" },
    //             {
    //               text: this.elements.codiceFiscaleIstituto,
    //               style: "tableText"
    //             }
    //           ],
    //           [
    //             {
    //               text: "Dirigente Scolastico/Legale Rappresentante",
    //               style: "tableTitle"
    //             },
    //             { text: this.elements.dirigenteIstituto, style: "tableText" }
    //           ],
    //           [
    //             { text: "Nato a", style: "tableTitle" },
    //             {
    //               text: this.elements.luogoNascitaDirigenteIstituto,
    //               style: "tableText"
    //             }
    //           ],
    //           [
    //             { text: "Nato il", style: "tableTitle" },
    //             {
    //               text: this.elements.dataNascitaDirigenteIstituto,
    //               style: "tableText"
    //             }
    //           ]
    //         ]
    //       }
    //     },
    //     {
    //       text: "E",
    //       alignment: "center",
    //       bold: true,
    //       fontSize: 13,
    //       margin: [0, 10, 0, 10]
    //     },
    //     {
    //       text: "Soggetto Ospitante",
    //       style: "bodyText",
    //       margin: [0, 10, 0, 10],
    //       bold: true
    //     },
    //     {
    //       table: {
    //         widths: [200, "*"],
    //         body: [
    //           [
    //             { text: "Denominazione Azienda", style: "tableTitle" },
    //             { text: this.elements.denominazioneAzienda, style: "tableText" }
    //           ],
    //           [
    //             { text: "Indirizzo sede Legale", style: "tableTitle" },
    //             { text: this.elements.indirizzoAzienda, style: "tableText" }
    //           ],
    //           [
    //             { text: "CAP Comune Provincia", style: "tableTitle" },
    //             {
    //               text:
    //                 this.elements.comuneAzienda +
    //                 " " +
    //                 this.elements.provinciaAzienda +
    //                 " " +
    //                 this.elements.capAzienda,
    //               style: "tableText"
    //             }
    //           ],
    //           [
    //             { text: "Telefono", style: "tableTitle" },
    //             { text: this.elements.telefonoAzienda, style: "tableText" }
    //           ],
    //           [
    //             { text: "Indirizzo e-mail", style: "tableTitle" },
    //             { text: this.elements.emailAzienda, style: "tableText" }
    //           ],
    //           [
    //             { text: "PEC", style: "tableTitle" },
    //             { text: this.elements.pecAzienda, style: "tableText" }
    //           ],
    //           [
    //             { text: "Codice Fiscale/Partita IVA", style: "tableTitle" },
    //             { text: this.elements.pIvaAzienda, style: "tableText" }
    //           ],
    //           [
    //             { text: "Legale Rappresentante", style: "tableTitle" },
    //             {
    //               text: this.elements.rappresentanteAzienda,
    //               style: "tableText"
    //             }
    //           ],
    //           [
    //             { text: "Nato/a a", style: "tableTitle" },
    //             {
    //               text: this.elements.luogoNascitaRappresentanteAzienda,
    //               style: "tableText"
    //             }
    //           ],
    //           [
    //             { text: "Nato/a il", style: "tableTitle" },
    //             {
    //               text: this.elements.dataNascitaRappresentante,
    //               style: "tableText"
    //             }
    //           ]
    //         ]
    //       },
    //       pageBreak: "after"
    //     },
    //     {
    //       text: "Premesso che:",
    //       style: "bodyText",
    //       bold: true,
    //       margin: [0, 70, 0, 5]
    //     },
    //     {
    //       text:
    //         "Il SOGGETTO PROMOTORE dichiara sotto la propria responsabilità di essere abilitato a promuovere tirocini in Regione Piemonte in quanto rientrante nella fattispecie di cui all’art. 4 della DGR n. 19-4575 del 16 gennaio 2017;",
    //       style: "bodyText"
    //     },
    //     {
    //       text:
    //         "Il SOGGETTO OSPITANTE dichiara sotto la propria responsabilità:",
    //       style: "bodyText"
    //     },
    //     {
    //       ul: [
    //         {
    //           text:
    //             "che i tirocinanti non saranno impiegati per sostituire lavoratori assenti con diritto alla conservazione del posto di lavoro;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "di essere in regola con la normativa di cui alla L. 68/99 (Norme per il diritto al lavoro dei disabili) e con l’applicazione dei contratti collettivi di lavoro.",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "di non assegnare al tutor individuato per ogni progetto formativo complessivamente più di n. 3 tirocinanti (compresi quelli eventualmente già presenti in azienda).",
    //           style: "bodyText"
    //         }
    //       ]
    //     },
    //     {
    //       text: "Si conviene quanto segue:",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 5]
    //     },
    //     {
    //       text: "Art. 1. Disposizioni generali",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text:
    //         "I tirocini estivi di orientamento hanno finalità orientative e di addestramento pratico in modo da agevolarne la scelta professionale, in coerenza con il percorso di studi frequentato.",
    //       style: "bodyText"
    //     },
    //     {
    //       text:
    //         "Sono esclusi dalla presente convenzione i tirocini curriculari previsti dai piani di studio e/o formativi, come quelli svolti nell’ambito dell’Alternanza Scuola Lavoro di cui alla Legge n. 107/2015.",
    //       style: "bodyText"
    //     },
    //     {
    //       text: "Il tirocinio non costituisce rapporto di lavoro.",
    //       style: "bodyText"
    //     },
    //     {
    //       text: "Art. 2. Ambito di applicazione e destinatari",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text:
    //         "Il tirocinio attivato nell’ambito della presente convenzione è disciplinato dalla normativa regionale approvata con DGR 19-4575 del 16 gennaio 2017, che approva la disciplina regionale dei tirocini estivi di orientamento, promossi durante la sospensione estiva delle attività didattiche a favore di un adolescente o di un giovane, regolarmente iscritto ad un ciclo di studi o ad un percorso formativo.",
    //       style: "bodyText"
    //     },
    //     {
    //       text: "Art. 3. Soggetti della convenzione.",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text:
    //         "Il soggetto ospitante <<denominazione azienda>> si impegna su proposta del soggetto promotore <<denominazione ist>> ad ospitare in qualità di tirocinanti presso le proprie unità operative soggetti in possesso degli specifici requisiti previsti dalla DGR 19- 4575 del 16 gennaio 2017, come evidenziato nel progetto formativo redatto dal soggetto promotore.",
    //       style: "bodyText"
    //     },
    //     {
    //       text: "Art. 4. Durata del tirocinio.",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text:
    //         "Il tirocinio estivo non può protrarsi oltre il 31 agosto 2020 (la durata consigliata è di 3-4 settimane).",
    //       style: "bodyText"
    //     },
    //     {
    //       text: "Art. 5. Rimborso spese.",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text:
    //         "Il tirocinio estivo prevede il riconoscimento di un rimborso a copertura delle spese di trasporto e di mensa, dietro presentazione di giustificativi, nella misura massima di un importo pari a € 200,00 mensili.",
    //       style: "bodyText"
    //     },
    //     {
    //       text: "Art. 6. Progetto formativo.",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text:
    //         "Le parti, in base alla presente Convenzione, si impegnano per ciascun tirocinante inserito nell’impresa ospitante a redigere il progetto formativo secondo il modello approvato dalla Regione Piemonte.",
    //       style: "bodyText"
    //     },
    //     {
    //       text:
    //         "Il progetto formativo contiene i seguenti elementi essenziali:",
    //       style: "bodyText"
    //     },
    //     {
    //       ul: [
    //         {
    //           text:
    //             "dati identificativi del soggetto promotore e del tutor o referente;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "dati identificativi del soggetto ospitante e del tutor aziendale;",
    //           style: "bodyText"
    //         },
    //         {
    //           text: "dati identificativi del tirocinante;",
    //           style: "bodyText"
    //         },
    //         {
    //           text: "obiettivi e modalità di svolgimento del tirocinio estivo;",
    //           style: "bodyText"
    //         },
    //         {
    //           text: "durata ed il periodo di svolgimento del tirocinio estivo;",
    //           style: "bodyText"
    //         },
    //         {
    //           text: "impegno orario settimanale presso l’impresa",
    //           style: "bodyText"
    //         },
    //         {
    //           text: "estremi identificativi delle assicurazioni;",
    //           style: "bodyText"
    //         },
    //         {
    //           text: "settore aziendale di inserimento (ATECO);",
    //           style: "bodyText",
    //           pageBreak: "after"
    //         },
    //         {
    //           text: "area professionale di riferimento (CP ISTAT);",
    //           style: "bodyText",
    //           margin: [0, 70, 0, 0]
    //         },
    //         {
    //           text: "figura professionale;",
    //           style: "bodyText"
    //         },
    //         {
    //           text: "obblighi dei soggetti coinvolti.",
    //           style: "bodyText"
    //         }
    //       ]
    //     },
    //     {
    //       text: "Art. 7. Obblighi del soggetto promotore.",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text:
    //         "Nel presidiare la qualità dell’esperienza di tirocinio il soggetto promotore deve:",
    //       style: "bodyText"
    //     },
    //     {
    //       ul: [
    //         {
    //           text:
    //             "favorire l’attivazione dell’esperienza di tirocinio supportando il soggetto ospitante e il tirocinante nella fase di avvio nella gestione delle procedure amministrative e nella predisposizione del progetto formativo secondo le disposizioni e i modelli regionali oggetto di apposito provvedimento;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "individuare un referente o tutor quale responsabile organizzativo/formativo del tirocinio;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "promuovere il buon andamento dell’esperienza di tirocinio attraverso un’azione di accompagnamento e monitoraggio in itinere;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "rilasciare il documento attestante le competenze acquisite, che dovrà essere redatto sulla base della relazione fornita dal tutor del soggetto ospitante.",
    //           style: "bodyText"
    //         }
    //       ]
    //     },
    //     {
    //       text: "Art. 8. Obblighi del soggetto ospitante.",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text: "Il soggetto ospitante deve:",
    //       style: "bodyText"
    //     },
    //     {
    //       ul: [
    //         {
    //           text:
    //             "stipulare la convenzione con il soggetto promotore e definire il progetto formativo, in collaborazione con il soggetto promotore;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "designare un tutor esterno/aziendale con funzioni di affiancamento al tirocinante sul luogo di lavoro, individuato tra i propri lavoratori in possesso di competenze professionali adeguate e coerenti con il progetto formativo individuale. Nel caso di imprese con meno di 15 dipendenti e di imprese artigiane, il tutor può essere il titolare o un amministratore dell’impresa, un socio o un famigliare coadiuvante inserito nell’attività dell’impresa;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "ad individuare nel Tutor esterno/aziendale un soggetto che sia competente e adeguatamente formato in materia di sicurezza e salute nei luoghi di lavoro;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "assicurare la realizzazione del percorso di tirocinio secondo quanto previsto dal progetto;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "valutare l’esperienza svolta dal tirocinante ai fini del rilascio, da parte del soggetto promotore, dell’attestazione dell’attività svolta e delle competenze eventualmente acquisite;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "affidare ai tirocinanti esclusivamente attività coerenti con gli obiettivi formativi del tirocinio stesso e il loro impegno presso l’impresa non dovrà superare l’orario previsto dal progetto formativo;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "adottare le misure di tutela applicate al proprio personale ai sensi del Decreto Legislativo n. 81/2008 (“Testo Unico in materia di tutela della salute e sicurezza sui luoghi di lavoro”), tenuto conto della peculiarità e della durata del rapporto di tirocinio estivo;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "segnalare tempestivamente al Soggetto Promotore e agli istituti assicurativi ogni eventuale incidente occorso durante lo svolgimento del tirocinio, entro i tempi previsti dalla normativa vigente;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "conservare la copia originale della convenzione e dei progetti di orientamento ed eventualmente esibirli su richiesta agli enti istituzionali presenti sul territorio.",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "a sospendere e/o interrompere l'attività di tirocinio, informando tempestivamente il Soggetto Promotore, nei casi in cui:",
    //           style: "bodyText"
    //         },
    //         {
    //           ul: [
    //             {
    //               text:
    //                 "la formazione alla sicurezza posseduta dagli studenti, in relazione al D. Lgs. 81/2008, non sia idonea allo svolgimento di una o più attività previste dal Progetto formativo;",
    //               style: "bodyText",
    //               margin: [50, 0, 0, 0]
    //             },
    //             {
    //               text:
    //                 "dovessero difettare o venir meno le condizioni di incolumità degli studenti in tirocinio in riferimento allo svolgimento di una o di tutte le attività previste dal Progetto Formativo;",
    //               style: "bodyText",
    //               margin: [50, 0, 0, 0]
    //             }
    //           ]
    //         },
    //         {
    //           text:
    //             "garantire agli studenti beneficiari del percorso, attraverso il Tutor esterno/aziendale, l’assistenza e la formazione necessarie al buon esito dell’attività prevista, nonché la dichiarazione delle competenze acquisite nel contesto di lavoro;",
    //           style: "bodyText"
    //         },
    //         {
    //           text: "consentire al Tutor scolastico di:",
    //           style: "bodyText"
    //         },
    //         {
    //           ul: [
    //             {
    //               text:
    //                 "monitorare l'attività mediante contatti telefonici e/o e-mail indirizzate al Tutor esterno;",
    //               style: "bodyText",
    //               margin: [50, 0, 0, 0]
    //             },
    //             {
    //               text:
    //                 "raggiungere e visitare gli studenti in tirocinio sul luogo effettivo di svolgimento dell'attività sia questo sede aziendale, cantiere mobile o reparto normalmente chiuso al pubblico.",
    //               style: "bodyText",
    //               margin: [50, 0, 0, 0]
    //             }
    //           ],
    //           pageBreak: "after"
    //         },
    //         {
    //           text:
    //             "a trasmettere al Soggetto Promotore, al fine di poter validare l’attività svolta, al termine del periodo:",
    //           style: "bodyText",
    //           margin: [0, 70, 0, 0]
    //         },
    //         {
    //           ul: [
    //             {
    //               text:
    //                 "il Registro presenze giornaliere (che certifica le ore effettivamente svolte);",
    //               style: "bodyText",
    //               margin: [50, 0, 0, 0]
    //             },
    //             {
    //               text:
    //                 "l'Attestato finale del Percorso Formativo (che valuta nel merito l’attività svolta e le competenze raggiunte);",
    //               style: "bodyText",
    //               margin: [50, 0, 0, 0]
    //             }
    //           ]
    //         },
    //         {
    //           text:
    //             "compilare il Questionario di soddisfazione dell'Azienda Ospitante al termine del periodo; è un documento online predisposto dall’Istituto per raccogliere informazioni sulla rispondenza dell’attività scolastica alle esigenze aziendali, utile anche all'analisi del fabbisogno di figure professionali sul territorio di riferimento;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "organizzare l’attività di tirocinio in modalità di “smart working”, almeno in parte (il tutor aziendale possa affiancare il tirocinante a distanza, con adeguati mezzi tecnologici);",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "garantire un’organizzazione degli spazi tale da ridurre al massimo il rischio di prossimità e di aggregazione, e che vengano adottate misure organizzative di prevenzione e di protezione, contestualizzate al settore produttivo di riferimento, con riguardo alle specifiche esigenze delle persone con disabilità, di cui al “Documento tecnico sulle possibile rimodulazione delle misure di contenimento del contagio da SARS – CoV- 2 nei luoghi di lavoro e strategie di prevenzione pubblicato dall’INAIL e di cui alla normativa sanitaria nazionale”.",
    //           style: "bodyText"
    //         }
    //       ]
    //     },
    //     {
    //       text:
    //         "Resta a carico del Soggetto Ospitante il far svolgere l’attività presso strutture aziendali (stabilimenti, sedi, reparti, uffici, ecc.) che rispettino le vigenti disposizioni normative in tema di prevenzione incendi, igiene e sicurezza del lavoro garantendo il rispetto di quanto previsto in materia di sorveglianza sanitaria ai sensi del D. Lgs. n. 81/2008, e a fornire, ai sensi dell’art. 37, all’avvio del tirocinio, sufficiente ed adeguata formazione specifica in materia e, ove necessario, gli eventuali dispositivi di protezione individuale (DPI).",
    //       style: "bodyText",
    //       margin: [0, 10, 0, 10]
    //     },
    //     {
    //       text:
    //         "Ai soli fini e per gli effetti del D. Lgs. n. 81/2008, il tirocinante è equiparato ai lavoratori nel solo periodo in cui svolge attività presso il Soggetto Ospitante, fermo restando la posizione di garanzia del Soggetto Promotore quale datore di lavoro dei tirocinanti.",
    //       style: "bodyText",
    //       margin: [0, 0, 0, 10]
    //     },
    //     {
    //       text: "Art. 9. Garanzie assicurative.",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text:
    //         "Il soggetto promotore è obbligato a stipulare, direttamente o in convenzione con il soggetto ospitante o con altri soggetti, l’assicurazione del tirocinante contro gli infortuni sul lavoro e per la responsabilità civile verso terzi. Le coperture assicurative devono riguardare anche le attività eventualmente svolte dal tirocinante al di fuori dell’azienda e rientranti nel progetto di orientamento.",
    //       style: "bodyText"
    //     },
    //     {
    //       text: "Art. 10. Durata della convenzione e recesso.",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text:
    //         "La presente convenzione ha validità dalla data di sottoscrizione alla data di fine tirocinio indicata sul progetto formativo, e si applicherà ad ogni tirocinio che avrà avuto inizio nell’arco temporale di vigenza, fino alla conclusione di questo, comprese le eventuali sospensioni e proroghe, fatte salve eventuali diverse disposizioni normative.",
    //       style: "bodyText"
    //     },
    //     {
    //       text:
    //         "Ciascuna delle parti firmatarie può recedere dagli obblighi presi con la sottoscrizione della presente Convenzione, relativamente ad uno o più dei tirocini attivati, solo per i seguenti motivi:",
    //       style: "bodyText"
    //     },
    //     {
    //       ul: [
    //         {
    //           text:
    //             "nel caso di comportamento del tirocinante tale da far venir meno le finalità del proprio progetto formativo individuale;",
    //           style: "bodyText"
    //         },
    //         {
    //           text:
    //             "qualora il soggetto ospitante non rispetti i contenuti del progetto formativo individuale o non consenta l’effettivo svolgimento dell’esperienza formativa del tirocinante.",
    //           style: "bodyText"
    //         }
    //       ]
    //     },
    //     {
    //       text:
    //         "Il recesso deve essere comunicato all’altra parte e al tirocinante per iscritto via lettera raccomandata o tramite PEC e avrà effetto dalla data di ricevimento della comunicazione.",
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text: "Art. 11. Consegna progetto formativo.",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text:
    //         "Le parti sono tenute a consegnare al tirocinante copia del progetto formativo e gli estremi della convenzione.",
    //       style: "bodyText",
    //       pageBreak: "after"
    //     },
    //     {
    //       text: "Art. 12. Trattamento dati personali.",
    //       bold: true,
    //       style: "bodyText",
    //       margin: [0, 70, 0, 0]
    //     },
    //     {
    //       text:
    //         "Ai sensi del decreto legislativo 30 giugno 2003, n. 196 'Codice in materia di protezione dei dati personali', il soggetto promotore e il soggetto ospitante dichiarano reciprocamente di essere informati e di acconsentire, espressamente, che i dati personali, concernenti i firmatari della presente convenzione e dell’allegato progetto formativo, comunque raccolti in conseguenza e nel corso dell’esecuzione della convenzione, saranno trattati esclusivamente per le finalità della convenzione stessa. Titolari del trattamento sono rispettivamente il soggetto ospitante e il soggetto promotore.",
    //       style: "bodyText"
    //     },
    //     {
    //       text:
    //         "Per tutto quanto non previsto dalla presente Convenzione le parti fanno riferimento alla legislazione vigente.",
    //       style: "bodyText"
    //     },
    //     {
    //       text: "Fossano, " + this.elements.dataDocumento,
    //       style: "bodyText",
    //       margin: [0, 10, 0, 0]
    //     },
    //     {
    //       text: "Firma SOGGETTO PROMOTORE",
    //       style: "bodyText",
    //       alignment: "right"
    //     },
    //     {
    //       text: "Il Dirigente Scolastico",
    //       style: "bodyText",
    //       alignment: "right"
    //     },
    //     {
    //       text: this.elements.dirigenteIstituto,
    //       style: "bodyText",
    //       bold: "true",
    //       alignment: "right"
    //     },
    //     {
    //       image: images.firmaVallauri,
    //       width: 200,
    //       alignment: "right"
    //     },
    //     {
    //       text: "Firma SOGGETTO OSPITANTE",
    //       style: "bodyText",
    //       alignment: "right",
    //       margin: [0, 70, 0, 0]
    //     },
    //     {
    //       text: "Legale Rappresentante",
    //       style: "bodyText",
    //       alignment: "right"
    //     },
    //     {
    //       text: this.elements.rappresentanteAzienda,
    //       style: "bodyText",
    //       bold: "true",
    //       alignment: "right"
    //     },
    //     {
    //       image: this.elements.firmaAzienda,
    //       width: 200,
    //       alignment: "right"
    //     }
    //   ],
    //   styles: {
    //     bodyText: {
    //       fontSize: 10,
    //       justified: true
    //     },
    //     tableTitle: {
    //       fontSize: 10,
    //       bold: "true",
    //       alignment: "right"
    //     },
    //     tableText: {
    //       fontSize: 8
    //     },
    //     tableTextHigh: {
    //       fontSize: 8,
    //       background: "yellow"
    //     }
    //   }
    // };
    var finalDocStr: string = this.completeDoc();
    var json = JSON.parse(finalDocStr);

    const pdfDocGenerator = pdfMake.createPdf(json);
    // const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  completeDoc(): string {
    var completeDoc: string = "";
    completeDoc = JSON.stringify(this.doc);
    completeDoc = completeDoc.replace(/%%_header_%%/g, images.authHeader);
    completeDoc = completeDoc.replace(/%%_footer_%%/g, images.authFooter);
    completeDoc = completeDoc.replace(/%%_headerDocVallauri_%%/g, images.headerDocVallauri);
    completeDoc = completeDoc.replace(/%%_footerDocVallauri_%%/g, images.footerDocVallauri);
    completeDoc = completeDoc.replace(
      /%%_denominazioneIstituto_%%/g,
      this.elements.denominazioneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoIstituto_%%/g,
      this.elements.indirizzoIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_capIstituto_%%/g,
      this.elements.capIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_comuneIstituto_%%/g,
      this.elements.comuneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaIstituto_%%/g,
      this.elements.provinciaIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoIstituto_%%/g,
      this.elements.telefonoIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_emailIstituto_%%/g,
      this.elements.emailIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_codiceFiscaleIstituto_%%/g,
      this.elements.codiceFiscaleIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_dirigenteIstituto_%%/g,
      this.elements.dirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaDirigenteIstituto_%%/g,
      this.elements.luogoNascitaDirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaDirigenteIstituto_%%/g,
      this.elements.dataNascitaDirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_denominazioneAzienda_%%/g,
      this.elements.denominazioneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoAzienda_%%/g,
      this.elements.indirizzoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_capAzienda_%%/g,
      this.elements.capAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_comuneAzienda_%%/g,
      this.elements.comuneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaAzienda_%%/g,
      this.elements.provinciaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoAzienda_%%/g,
      this.elements.telefonoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_emailAzienda_%%/g,
      this.elements.emailAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pecAzienda_%%/g,
      this.elements.pecAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pIvaAzienda_%%/g,
      this.elements.pIvaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_rappresentanteAzienda_%%/g,
      this.elements.rappresentanteAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaRappresentanteAzienda_%%/g,
      this.elements.luogoNascitaRappresentanteAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaRappresentante_%%/g,
      this.elements.dataNascitaRappresentante
    );
    completeDoc = completeDoc.replace(
      /%%_dataDocumento_%%/g,
      this.elements.dataDocumento
    );
    completeDoc = completeDoc.replace(
      /%%_firmaAzienda_%%/g,
      this.elements.firmaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_firmaIstituto_%%/g,
      this.elements.firmaIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_tipoAttivita_%%/g,
      this.elements.tipoAttivita
    );
    completeDoc = completeDoc.replace(
      /%%_numeroProtocollo_%%/g,
      this.elements.numeroProtocollo
    );

    return completeDoc;
  }

  confirm() {
    var payload = {
      idConvenzione: this.elements.idConvenzione
    };
    if (this.elements.firmaAzienda !== null) {
      user
        .dispatchConfirmConvenzione(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Convenzione accettata con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda mancante"
      );
    }
  }
  refuse() {
    var payload = {
      idConvenzione: this.elements.idConvenzione
    };
    if (this.elements.firmaAzienda !== null) {
      user
        .dispatchRefuseConvenzione(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Convenzione rifiutata con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda mancante"
      );
    }
  }

  close() {
    bus.$emit("closeReview");
  }

  created() {
    // var userInfo = user.readUserInfo(this["$store"]);
    // if (userInfo === null) {
    //   userInfo = user.readStudentInfo(this["$store"]);
    // }
    // this.ruoloUtente = userInfo.ruoloUtente;
    // this.createDoc();

    data
      .dispatchTemplateDoc(this["$store"], this.docInfo.idTemplate)
      .then(result => {
        this.doc = result;
        if (this.docInfo.tipoAttivita === "tirocinioReIns") {
          this.tipoAttivita = "tirocinio di inserimento/reinserimento";
        } else if (this.docInfo.tipoAttivita === "tirocinioFormativo") {
          this.tipoAttivita = "tirocinio formativo e di orientamento";
        }
        var userInfo = user.readUserInfo(this["$store"]);
        if (userInfo === null) {
          userInfo = user.readStudentInfo(this["$store"]);
        }
        this.ruoloUtente = userInfo.ruoloUtente;
        this.createDoc();
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }
}
